import React from 'react';
import { useSelector } from 'react-redux';
import router from 'next/router';
import { Alert, Button, Space } from 'antd';
import NftDetails from './NftDetails';

export default function SelectNftTypeComponent(props) {
  const userDataRedux = useSelector((state) => state.authReducer.userData);
  const { userP2Detail, userDetail, apiCalled } = props;

  const showP2DetailsPopUp = () => {
    return (
      !(userP2Detail && userDetail.issuerContact) &&
      apiCalled && (
        <div
          className="container"
          style={{ paddingTop: 30, paddingBottom: 30 }}
        >
          <Alert
            showIcon
            className="flex items-center"
            description="Please fill out the form with your personal data before you start minting."
            type="info"
            action={
              <div className="alert__button">
                <Button
                  shape
                  type="primary"
                  onClick={() =>
                    router.push(`/PII/${userDataRedux.uid}/?page=mintNFT`)
                  }
                >
                  Continue
                </Button>
                <Button
                  className=""
                  shape
                  danger
                  type="ghost"
                  onClick={() => router.push(`/`)}
                >
                  Cancel Minting
                </Button>
              </div>
            }
          />
        </div>
      )
    );
  };

  return (
    <>
      <main className="main">
        <div className="main_wrapper">
          <div
            className="w-full container"
            style={{ padding: '0px', margin: '0px' }}
          >
            <ul className="breadcrumb">
              <li className="breadcrumb__item">
                <a href="/" className="crumb_item">
                  Home
                </a>
              </li>
              <li className="breadcrumb__item breadcrumb__item--active">
                Mint
              </li>
            </ul>
          </div>
          <div>
            <div className="w-full px-4">
              <div className="mint__title mint__title--center my-4">
                <div className="w-full text-center">
                  <h2 className="mint_title_color">Mint NFT</h2>
                </div>
                <h4 className="text-center my-4">
                  You can mint your collectible to be one of a kind or you can
                  mint a limited edition.
                </h4>
              </div>
            </div>
          </div>
        </div>

        {showP2DetailsPopUp()}

        <div className="container">
          <div className="row row--grid">
            {/* <div className="row row--grid mt-12">
              <div className="w-full xl:w-6/12 px-4">
                <div className="nft__type">
                  <div className="mint__cover">
                    <img src="/img/SingleNft.png" />
                  </div>
                  <a href="/mintNft/mintSingle" className="mint__btn">
                    Mint Single
                  </a>
                </div>
              </div>
              <div className="w-full xl:w-6/12 px-4">
                <div className="nft__type">
                  <div className="mint__cover">
                    <img src="/img/MultipleNft.png" />
                  </div>
                  <a href="/mintNft/mintMultiple" className="mint__btn">
                    Mint Multiple
                  </a>
                </div>
              </div>
            </div> */}
            <div className="w-full">
              <NftDetails {...props} />
            </div>
          </div>
        </div>
      </main>
    </>
  );
}
